import type { Enrollment } from '@/views/Enrollments/Show';
import type { EnrollmentResult } from '@/views/Enrollments/WalkThrough/Results';

export default {
  enrollment: null as Enrollment | null,
  enrollmentResult: null as EnrollmentResult | null,
};
